<script lang="ts" setup>
import { Header } from '@brighterly/lib-lumee-ui'

import { useScreenWidth } from '@hooks/feature-tour/screen-width.hook'
import { useHeaderLogo } from '@composables/widgets/menu/header-logo.hook'

import { useAppLogoDomain } from '@UI/Logos/AppLogoDomain/composables/use-app-logo-domain.hook'
import HeaderMenu from '@Widgets/Menu/HeaderMenu.vue'
import KidSwitcher from '@Widgets/KidsMenu/KidSwitcher.vue'

defineOptions({
  name: 'AppHeader',
})

const { logoBrand } = useAppLogoDomain()

const {
  homeUrl,
  trackLogoClick,
} = useHeaderLogo()

const { isMobile } = useScreenWidth()
</script>

<template>
  <div class="app-header">
    <Header
      :brand="logoBrand"
      :logo-href="homeUrl"
      @logo-click="trackLogoClick"
    >
      <template
        v-if="!isMobile"
        #navSlot
      >
        <HeaderMenu layout="horizontal" />
      </template>
      <template #account>
        <KidSwitcher />
      </template>
    </Header>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/AppHeader.scss" />
